import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import * as productsApi from '@/api/products'

// ========== Prodotti ==========

export const useProdotti = (params) => {
  return useQuery({
    queryKey: ['prodotti', params],
    queryFn: () => productsApi.getProdotti(params).then(res => res.data),
  })
}

export const useProdotto = (id) => {
  return useQuery({
    queryKey: ['prodotti', id],
    queryFn: () => productsApi.getProdotto(id).then(res => res.data),
    enabled: !!id,
  })
}

export const useProdottiAttivi = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['prodotti', 'attivi'],
    queryFn: () => productsApi.getProdottiAttivi().then(res => res.data),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minuti
  })
}

export const useProdottiPerCategoria = () => {
  return useQuery({
    queryKey: ['prodotti', 'per-categoria'],
    queryFn: () => productsApi.getProdottiPerCategoria().then(res => res.data),
    staleTime: 5 * 60 * 1000,
  })
}

// ========== Categorie ==========

export const useCategorie = (params) => {
  return useQuery({
    queryKey: ['categorie', params],
    queryFn: () => productsApi.getCategorie(params).then(res => res.data),
  })
}

export const useCategorieAttive = () => {
  return useQuery({
    queryKey: ['categorie', 'attive'],
    queryFn: () => productsApi.getCategorieAttive().then(res => res.data),
    staleTime: 5 * 60 * 1000,
  })
}

// ========== Fornitori ==========

export const useFornitori = (params) => {
  return useQuery({
    queryKey: ['fornitori', params],
    queryFn: () => productsApi.getFornitori(params).then(res => res.data),
  })
}

export const useFornitoriAttivi = () => {
  return useQuery({
    queryKey: ['fornitori', 'attivi'],
    queryFn: () => productsApi.getFornitoriAttivi().then(res => res.data),
    staleTime: 5 * 60 * 1000,
  })
}
